import { getApi } from '../../../src/ts/libs/getApi';
import format from 'date-fns/format';

interface AddressLookupError {
  message: string;
}
export interface SingleAddressItem {
  id: string;
  domesticId: string;
  adminAreaName: string;
  barcode: string;
  buildingName: string;
  buildingNumber: number;
  city: string;
  company: string;
  countryIso2: string;
  countryIso3: string;
  countryIsoNumber: number;
  countryName: string;
  district: string;
  line1: string;
  line2: string;
  line3: string;
  line4: string;
  line5: string;
  latitude: string;
  longitude: string;
  poBox: string;
  postalCode: string;
  province: string;
  secondaryStreet: string;
  street: string;
  subBuilding: string;
  department: string;
}

export interface SingleAddressLookup {
  item?: SingleAddressItem;
  errors?: AddressLookupError[];
}

export interface AddressItem {
  key: string;
  text: string;
  type: string;
}

export interface AddressLookup {
  items?: AddressItem[];
  errors?: AddressLookupError[];
}

const { hostname } = window.location;

let API_KEY =
  hostname === 'localhost' ? 'd03f5123-b8f8-4977-81ac-9f82048e3b36' : '8ef186d0-5210-4234-99bb-07b57ee7e86c';
switch (hostname) {
  case 'fargro.netlify.app':
    API_KEY = 'd03f5123-b8f8-4977-81ac-9f82048e3b36';

    break;
  case 'localhost':
    API_KEY = 'd03f5123-b8f8-4977-81ac-9f82048e3b36';

    break;
  case 'fargro.local':
    API_KEY = 'd03f5123-b8f8-4977-81ac-9f82048e3b36';

    break;
  case 'uat.fargro.coldbanana.tech':
    API_KEY = '8ef186d0-5210-4234-99bb-07b57ee7e86c';

    break;

  default:
    API_KEY = 'fb54c328-13f8-4c20-b475-db65e6c5619e';
}

const LOOKUP_BASE = 'https://wsp.epostcode.com/uk/v1';

const getAddressList = async (postcode) => {
  try {
    const response = await fetch(`${LOOKUP_BASE}/search?key=${API_KEY}&phrase=${encodeURIComponent(postcode)}`);
    const data = (await response.json()) as AddressLookup;

    if (data?.errors) {
      alert(`Error: ${data.errors[0].message}`);
      return false;
    }

    return data;
  } catch (error) {
    console.error(error);
    return false;
  }
};

const getSingleAddress = async (id) => {
  try {
    const response = await fetch(`${LOOKUP_BASE}/getpremise?key=${API_KEY}&id=${id}`);
    const data = (await response.json()) as SingleAddressLookup;

    if (data?.errors) {
      alert(`Error: ${data.errors[0].message}`);
      return false;
    }

    return data;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export interface AddressWindow extends Window {
  GetAddress: () => any;
  MicroModal: any;
}
declare let window: AddressWindow;

const ADDRESS_MAP = {
  '0': 'Delivery',
  '1': 'Customer',
  '2': 'Company',
  '3': 'Custom',
};

(function () {
  function handleDeliverySelected() {
    const hiddenClass = 'is-hidden';
    const datePickerEl = document.querySelector('.js-date-picker');
    const id = this.id;

    if (id === 'chooseDate') {
      datePickerEl.classList.remove(hiddenClass);
    } else {
      datePickerEl.classList.add(hiddenClass);
    }
  }

  const deliverDateChoseEls = document.querySelectorAll('input[name="deliveryDate"]');

  deliverDateChoseEls.forEach((option) => {
    option.addEventListener('click', handleDeliverySelected);
  });

  const passwordToggles = document.getElementsByClassName('form-field--password-toggle');

  for (let ind = 0; ind < passwordToggles.length; ind++) {
    const toggle = passwordToggles[ind];

    toggle.addEventListener('click', (evt) => {
      const siblingField = toggle?.parentElement?.querySelector('input');
      const fieldType = siblingField.getAttribute('type');

      if (fieldType == 'password') {
        siblingField.setAttribute('type', 'text');
      } else {
        siblingField.setAttribute('type', 'password');
      }
    });
  }

  const addressLookup = document.getElementsByClassName('address-picker');
  const findAddressSubmit = document.getElementById('epcFindAddresses');

  if (addressLookup && findAddressSubmit) {
    const selectAddressContainer = document.getElementById('selectAddress');
    const selectAddressInput = document.querySelector<HTMLSelectElement>('#epcAddressList');
    const manualAddressTrigger = document.getElementsByClassName('address-lookup__manual-add-toggle');
    const manualAddressContainer = document.getElementsByClassName('address-lookup__manual-entry');

    // lookup

    const lookupPostcodeBtn = document.querySelector<HTMLButtonElement>('#epcFindAddresses');
    const lookupNumberValue = document.querySelector<HTMLInputElement>('#epcSearchNumber');
    const lookupPostcodeValue = document.querySelector<HTMLInputElement>('#epcSearchPostcode');

    if (lookupPostcodeBtn) {
      lookupPostcodeBtn.addEventListener('click', () => {
        const { value } = lookupPostcodeValue;

        const searchValue = lookupNumberValue?.value ? `${lookupNumberValue.value}, ${value}` : value;

        selectAddressInput.innerHTML = `<option value="" disabled>Loading...</option>`;
        getAddressList(searchValue).then((lookup) => {
          if (lookup && lookup?.items && lookup.items.length === 0) {
            selectAddressInput.innerHTML = `
            <option value="">No Address found</option>`;

            return;
          }

          if (selectAddressInput && lookup) {
            selectAddressInput.innerHTML = `
        <option value="">Please select address</option>
        ${lookup?.items?.map((item) => `<option value="${item.key}">${item.text}</option>`)}
        `;
          } else {
            selectAddressInput.innerHTML = `<option value="" disabled>Not address found</option>`;
          }
        });
      });
    }
    if (findAddressSubmit) {
      findAddressSubmit.addEventListener('click', () => {
        selectAddressContainer.classList.remove('is-hidden');
        manualAddressContainer[0].classList.add('is-hidden');
        if (manualAddressTrigger && manualAddressTrigger.length > 0) {
          manualAddressTrigger[0].classList.remove('is-hidden');
        }
        // document.getElementById("epcAddressList").insertBefore(new Option('Select an address', ''), document.getElementById("epcAddressList").firstChild);
      });
    }

    if (manualAddressTrigger && manualAddressTrigger.length > 0) {
      manualAddressTrigger[0].addEventListener('click', () => {
        selectAddressContainer.classList.add('is-hidden');
        manualAddressContainer[0].classList.remove('is-hidden');
      });
    }

    if (selectAddressInput) {
      selectAddressInput.addEventListener('change', (evt) => {
        const { value } = selectAddressInput;

        // window.GetAddress();
        getSingleAddress(value).then((address) => {
          manualAddressContainer[0].classList.remove('is-hidden');

          if (address) {
            const company = document.querySelector<HTMLInputElement>('#epcSearchCompany');
            const addressLine1 = document.querySelector<HTMLInputElement>('#epcAddressLine1');
            const addressLine2 = document.querySelector<HTMLInputElement>('#epcAddressLine2');
            const addressTown = document.querySelector<HTMLInputElement>('#epcTownOrCity');
            const addressCounty = document.querySelector<HTMLInputElement>('#epcCounty');
            const addressPostcode = document.querySelector<HTMLInputElement>('#epcPostcode');
            if (address?.item) {
              addressLine1.value = address?.item?.line1;
              addressLine2.value = address?.item?.line2;
              addressTown.value = address?.item?.city;
              if (company && address?.item.company) {
                company.value = address?.item.company;
              }
              if (addressCounty && address?.item.province) {
                addressCounty.value = address?.item.province;
              }
              if (addressPostcode && address?.item.postalCode) {
                addressPostcode.value = address?.item.postalCode;
              }
            }
          }
        });
      });
    }
  }

  // if new address add that else use selected address
  const addAddressAction = document.querySelector('#address-picker .modal__actions__close-btn');
  const toggleNewAddressAction = document.querySelector('#address-picker [data-toggle-action]');

  const addressCompany = document.querySelector('#epcSearchCompany') as HTMLInputElement;
  const addressLine1 = document.querySelector('#epcAddressLine1') as HTMLInputElement;
  const phone = document.querySelector('#phoneNumber') as HTMLInputElement;
  const addressLine2 = document.querySelector('#epcAddressLine2') as HTMLInputElement;
  const addressTown = document.querySelector('#epcTownOrCity') as HTMLInputElement;
  const addressCounty = document.querySelector('#epcCounty') as HTMLInputElement;
  const addressPostcode = document.querySelector('#epcSearchPostcode') as HTMLInputElement;
  const addressPostcodeSearch = document.querySelector('#epcPostcode') as HTMLInputElement;
  const selectedFormInput = document.querySelector('#AddressId') as HTMLInputElement;
  const selectedContactTypeInput = document.querySelector('#AddressType') as HTMLInputElement;

  // if user toggles form reset the labels
  if (toggleNewAddressAction) {
    toggleNewAddressAction.addEventListener('click', () => {
      addAddressAction.classList.add('is-active');
      phone.value = '';
      addressCompany.value = '';
      addressLine1.value = '';
      addressLine2.value = '';
      addressTown.value = '';
      addressCounty.value = '';
      addressPostcode.value = '';
      addressPostcodeSearch.value = '';
    });
  }
  if (addAddressAction) {
    addAddressAction.addEventListener('click', async (evt) => {
      evt.preventDefault();

      const addressPicker = document.querySelector('.address-picker__value');

      const radioGroup = document.querySelector('.address-picker .radio-selection');
      const isPaymentPage = !!document.getElementById('checkout-payment');

      const AddressLine1Elm = document.getElementById('AddressLine1') as HTMLInputElement;
      const AddressLine2Elm = document.getElementById('AddressLine2') as HTMLInputElement;
      const CityElm = document.getElementById('City') as HTMLInputElement;
      const PostCodeElm = document.getElementById('PostCode') as HTMLInputElement;

      // close the modal then workout what needs to happen
      window.MicroModal.close('address-picker');

      if (
        (addressLine1?.value?.length >= 1 || addressLine2?.value?.length >= 1) &&
        addressPostcode?.value?.length >= 1
      ) {
        const newEntry = `
        <strong class="heading">${addressCompany?.value}</strong>
        <p>${addressLine1?.value ? addressLine1.value + ' ' : ''}${
          addressLine2?.value ? addressLine2.value + ' ' : ''
        }${addressTown?.value ? addressTown.value + ' ' : ''}${addressCounty?.value ? addressCounty.value + ' ' : ''}${
          addressPostcode?.value ? addressPostcode.value + ' ' : ''
        }</p>
        `;

        addressPicker.innerHTML = newEntry;
        let newId = '';
        const url = getApi('addAddress');
        try {
          if (!isPaymentPage) {
            const res: any = await fetch(url, {
              method: 'POST',
              headers: { 'content-type': 'application/json' },
              body: JSON.stringify({
                Phone: phone?.value ? phone.value + ''.trim() : '',
                CompanyName: addressCompany?.value ? addressCompany.value + ''.trim() : '',
                'Address.AddressLine1': addressLine1?.value ? addressLine1.value + ''.trim() : '',
                'Address.AddressLine2': addressLine2?.value ? addressLine2.value + ''.trim() : '',
                'Address.City': addressTown?.value ? addressTown.value + ''.trim() : '',
                'Address.County': addressCounty?.value ? addressCounty.value + ''.trim() : '',
                'Address.Country': null,
                'Address.PostCode': addressPostcode?.value ? addressPostcode.value + ''.trim() : '',
              }),
            });

            const data: any = await res.json();

            if (data && data?.ExceptionMessage?.length > 1) {
              alert(`${data.Message}`);
              return;
            }
            if (!data) {
              return;
            }

            // get ID
            newId = data?.addressId;
            const idType = data?.addressType;

            const idName = ADDRESS_MAP[`${idType}`];

            if (selectedFormInput) {
              selectedFormInput.value = newId;
            }

            if (selectedContactTypeInput) {
              selectedContactTypeInput.value = idName;
            }

            // must be the delivery page so lets try this
            // update delivery dates
            if (document.querySelector('#date-picker')) {
              const fp = (document.querySelector('#date-picker') as any)._flatpickr;
              const [nextDate] = data?.deliveryDataJson.availableDeliveryDays;
              fp.set('minDate', nextDate);
              fp.set('enable', data?.deliveryDataJson.availableDeliveryDays);

              const formatDate = format(new Date(nextDate), 'EEEE d MMMM');

              const nextAvailableElm = document.querySelector('#nextAvailable + label strong') as HTMLElement;
              const NextDeliveryDate = document.getElementById('#NextDeliveryDate') as HTMLInputElement;
              if (nextAvailableElm && formatDate) {
                nextAvailableElm.innerText = formatDate;
                if (NextDeliveryDate) {
                  NextDeliveryDate.value = nextDate;
                }
              }
            }
          } else {
            if (selectedFormInput) {
              selectedFormInput.value = '0';
            }
          }

          // Append
          const newModalRadioItem = document.createElement('div');
          newModalRadioItem.classList.add('radio-selection__radio');
          newModalRadioItem.innerHTML = `
        <input id="${newId ? newId : 'billingAddressAdded'}" data-address-id="${
            newId ? newId : 'billingAddressAdded'
          }" type="radio" name="addressBook">
        <label for="${newId ? newId : 'billingAddressAdded'}">${newEntry}</label>
      `;

          radioGroup.appendChild(newModalRadioItem);

          if (!isPaymentPage) {
            newModalRadioItem.querySelector('input').checked = true;
          }

          // toggle the view back as next time we would want the list again
          const toggleTarget = document.querySelector('#address-picker [data-toggle]');
          const event = new Event('toggle');
          toggleTarget.dispatchEvent(event);

          // is it the billing/payment page?

          if (isPaymentPage) {
            AddressLine1Elm.value = addressLine1?.value ? addressLine1.value + '' : '';
            AddressLine2Elm.value = addressLine2?.value ? addressLine2.value + '' : '';
            CityElm.value = addressTown?.value ? addressTown.value + '' : '';
            PostCodeElm.value = addressPostcode?.value ? addressPostcode.value + '' : '';
          }

          // reset the fields
          addressCompany.value = '';
          addressLine1.value = '';
          addressLine2.value = '';
          addressTown.value = '';
          addressCounty.value = '';
          addressPostcode.value = '';
          addressPostcodeSearch.value = '';
          document.getElementById('selectAddress').classList.add('is-hidden');

          // is it the billing/payment page? we don't need to go any further
          if (isPaymentPage) {
            return;
          }
        } catch (e) {
          console.error(e);
        }
      } else {
        // we just selected an existing address
        const selectedAddressText = document.querySelector(
          '#address-picker input[name=addressBook]:checked + label'
        ).innerHTML;
        const selectedOption = document.querySelector<HTMLInputElement>(
          '#address-picker input[name=addressBook]:checked'
        );

        if (selectedFormInput && selectedOption) {
          selectedFormInput.value = selectedOption.getAttribute('data-address-id');
        }

        if (addressPicker) {
          addressPicker.innerHTML = selectedAddressText;
        }

        if (isPaymentPage) {
          AddressLine1Elm.value = addressLine1?.value ? addressLine1.value + ' ' : '';
          AddressLine2Elm.value = addressLine2?.value ? addressLine2.value + ' ' : '';
          CityElm.value = addressTown?.value ? addressTown.value + ' ' : '';
          PostCodeElm.value = addressPostcode?.value ? addressPostcode.value + ' ' : '';

          return;
        }

        try {
          const availableDates = document.getElementById(`${selectedOption.id}-delivery-data`);
          // Check we have correct data
          if (availableDates && availableDates?.innerHTML?.includes('availableDeliveryDays')) {
            const { availableDeliveryDays } = JSON.parse(availableDates.innerHTML);

            const fp = (document.querySelector('#date-picker') as any)._flatpickr;
            const [nextDate] = availableDeliveryDays;
            if (availableDeliveryDays) {
              fp.set('enable', availableDeliveryDays);
            }
            if (nextDate) {
              fp.set('minDate', nextDate);

              try {
                const formatDate = format(new Date(nextDate), 'EEEE d MMMM');

                const nextAvailableElm = document.querySelector('#nextAvailable + label strong') as HTMLElement;
                const NextDeliveryDate = document.getElementById('#NextDeliveryDate') as HTMLInputElement;
                if (nextAvailableElm && formatDate) {
                  nextAvailableElm.innerText = formatDate;
                  if (NextDeliveryDate) {
                    NextDeliveryDate.value = nextDate;
                  }
                }
              } catch (e) {
                console.warn(e);
              }
            }
          }
        } catch (e) {
          console.error(e);
        }
      }

      // we now need to update delivery address

      // CLose the modal
      window.MicroModal.close('address-picker');
    });
  }
})();
